import React from 'react';
import propTypes from 'prop-types';
import { concatClassName } from '@dateam/ark-react';
import styles from './Sidebar.module.scss';

type Props = {
    className?: string;
    children?: React.ReactNode;
};

const SidebarSeparator: React.FC<Props> = ({
    className,
    children
}: Props) => (
    <hr className={concatClassName(styles['separator'], className)}></hr>
);

SidebarSeparator.propTypes = {
    className: propTypes.string,
    children: propTypes.node
};

SidebarSeparator.defaultProps = {
    className: undefined,
    children: undefined
};

export default SidebarSeparator;
